import { Alert, Divider, Text } from "@amzn/storm-ui";
import React from "react";

import { LoadingSpinner } from "../../LoadingSpinner";

export interface HydrationPromptProps {
    requiresHydration?: boolean;
    isHydrationDone?: boolean;
    hydrationErrorMessages: [string, string, string, string][];
}

export const HydrationPrompt: React.FC<HydrationPromptProps> = (props) => {
    const [dismissedHydrationMessages, setDismissedHydrationMessages] =
        React.useState<boolean>(false);
    const { isHydrationDone, requiresHydration, hydrationErrorMessages } =
        props;

    if (!requiresHydration || dismissedHydrationMessages) return null;

    if (!isHydrationDone) return <LoadingSpinner prompt="Populating Inputs" />;

    return (
        <>
            {hydrationErrorMessages.length > 0 ? (
                <>
                    <Alert
                        variant="warning"
                        header="Insight input auto population failed"
                        onClose={() => setDismissedHydrationMessages(true)}
                        withCloseButton={true}
                    >
                        <Text>The following inputs failed to repopulate:</Text>
                        <Divider />
                        {hydrationErrorMessages.map(
                            ([_id, dimension, cause]) => (
                                <div>
                                    <Text key={dimension} size="xsmall">
                                        {dimension}:{cause}
                                    </Text>
                                </div>
                            ),
                        )}
                    </Alert>
                    <Divider />
                </>
            ) : (
                <>
                    <Alert
                        variant="success"
                        header="Successfully populated inputs"
                        onClose={() => setDismissedHydrationMessages(true)}
                        withCloseButton={true}
                    ></Alert>
                    <Divider />
                </>
            )}
        </>
    );
};
